import store from '../../../../store';
export default function checkIfCanAdd() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (scopes.includes('system_roles_add_company') || scopes.includes('system_roles_add_all')) {
    exists = true;
  }
  return exists;
}
